import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const BannerStatusIcon = ({
    bgColor,
    borderColor,
    ...props
}: { bgColor: string; borderColor: string } & SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <circle
                cx="12"
                cy="12"
                r="9.5"
                fill={bgColor}
                stroke={borderColor}
            />
        </SvgIcon>
    );
};

export default BannerStatusIcon;
